module.exports = __webpack_public_path__ + "static/media/oge1.png.0038f657.jpg";